import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { capitalize } from '@attain-apps/string-utils'

import * as state from '../../../../../../../../state'
import * as rendering from '../../../../rendering'

/**
 * Number of milliseconds to debounce rapid updates to the widget query
 *
 * I.e. if multiple updates are made in less than this number of milliseconds,
 * only the last of those updates will actually be applied
 */
const UPDATE_DEBOUNCE_MS = 500

@ngCore.Component({
  imports: [
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    ngCommon.JsonPipe,
    ds.input.text.Component,
    ds.input.code.Component,
    ds.tabs.floatingHorizontal.Component,
    rendering.widget.Component,
    ds.loader.Component,
  ],
  selector: 'atn-widget-builder-query-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link AtnMosaicEcService.widgetsCollection} */
  public readonly widgetsEc = ngCore.inject(state.mosaic.dev.widgets.Collection)

  /** @see {@link state.dms.schema.Feature} */
  public readonly schemaFeature = ngCore.inject(state.dms.schema.Feature)

  // NOTE: defined here just because we cant use namespace directly in the
  // template
  /**
   * @see
   * {@link state.mosaic.models.widget.Ref.Id.FOR_PREVIEW}
   */
  public readonly widgetRefIdForPreview =
    state.mosaic.models.widget.Ref.Id.FOR_PREVIEW

  /** @see {@link state.mosaic.dev.widgets.plugins.preview.Plugin} */
  public readonly widgetPreviewPlugin = this.widgetsEc.plugins
    .lookup(state.mosaic.dev.widgets.plugins.preview.Plugin)
    .get()

  /**
   * Run query button click handler.
   * Gets widget preview from written query.
   */
  public runQuery = (source: string) => {
    const id = this.widgetsEc.plugins.currentEntityPlugin.feature.selectors
      .getId()
      .asSignal()
    const widget = this.widgetsEc.plugins.currentEntityPlugin.feature.selectors
      .getLatestEntity()
      .asSignal()
    if (id && widget?.query) {
      this.widgetPreviewPlugin.feature.actions.preview
        .from(`Dialog.${source}`)
        .dispatch({ flexibleIdentifier: { id }, query: widget.query })
    }
  }

  /**
   * Update widget property handler
   */
  public updateWidget<K extends keyof ents.core.mosaic.Widget.Input>(
    prop: K,
    value: ents.core.mosaic.Widget.Input[K],
  ): void {
    this.widgetsEc.plugins.editingPlugin.feature.actions.edit
      .from(`Dialog.${capitalize(prop)}.Inputted`)
      .dispatch({
        edit: widget => {
          if (!widget) {
            return
          }
          widget[prop] = value
        },
        id: this.widgetsEc.plugins.currentEntityPlugin.feature.selectors
          .getId()
          .asSignal(),
      })
  }

  /** Updates widget query on query change. */
  public updateWidgetQuery(query: unknown): void {
    // NOTE: we just hope the query is structured properly
    this.updateWidget('query', query as ents.core.mosaic.Widget.Query)
  }
}
